import {FC, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {Box, Typography} from "@mui/material";
import {ICourseEntity, ICourseEntityPayload} from "@buildwitt/shapeshift-types";
import Editor from "../../../../components/admin/WYSIWYG/Editor";
import AdminCourseCurriculum from "./AdminCourseCurriculum/CourseCurriculum";
import {IDropzoneFile} from "@buildwitt/shapeshift-common/v1/fileDropzone/fileDropzone";
import {AdminInputText, AdminEntityPageContainer, AdminFileInput, AdminFieldContainer, AdminInputSwitch, AdminInputSelect, AdminFormContainer, ConfirmDeleteEntityDialog, AdminEntityPageContainerProps} from "@buildwitt/shapeshift-common/v2/admin"
import {cohortCourseValidationDoc} from "../../../../validationDocs/user/cohortCourseValidationDoc";


const useStyles = makeStyles()((_theme) => ({
	adminCoursePage: {}
}));

interface IProps extends Partial<AdminEntityPageContainerProps<ICourseEntity, "course">> {
	courseId?: number,
	className?: string
}

const template: ICourseEntityPayload = {
	title: "", slug: "", content: "", description: "", curriculum: [],
	featuredImage: null
}

const contentTypes: string[] = ["Job Training", "Safety", "Personal Development", "Professional Development"]

export const AdminCoursePageContent: FC<IProps> = ({courseId, ...props}) => {
	const entityId = courseId;

	const ICourseEntityToICourseEntityPayload = (e: ICourseEntity): ICourseEntityPayload => {
		const {title, slug, content, id, createdAt, updatedAt, privacy, description, linearProgression} = e
		const featuredImage = e.featuredImage?.id
		const contentType = (e as any).contentType;
		const payload = {
			title, slug, content, id, createdAt, updatedAt, privacy, description, contentType, featuredImage, linearProgression
		}
		return payload;
	}

	return (
		<AdminEntityPageContainer<ICourseEntity & ICourseEntityPayload & {enrollmentCount?: number}, "course">
			entityId={entityId}
			entityToPayload={ICourseEntityToICourseEntityPayload}
			template={template}
			validationDoc={cohortCourseValidationDoc}
			type="course"
			componentOverrides={{
				adminFormContainer: ({entity, ...containerProps}) =>
					<AdminFormContainer {...containerProps} entity={entity}
						componentOverrides={{deleteDialog: deleteProps => <ConfirmDeleteEntityDialog {...deleteProps} componentOverrides={{content:  entity?.enrollmentCount && entity?.enrollmentCount >= 1 ? <Typography variant="body1">You will be making an assigned course unavailable.</Typography> : <Typography variant="body1">Do you want to delete?</Typography>}}/>}}/>
			}}
			{...props}
		>
			{({formData, setFormData, entity, locale, files, setFiles, validation}) => <>
				{/* <AdminInputText label="Slug" onChange={e => setFormData(prev => ({...prev, slug: e.target.value}))} value={formData.slug}/> */}
				<AdminInputText error={validation?.[0]?.title} required label="Title" onChange={e => setFormData(prev => ({...prev, title: e.target.value}))} value={formData.title} />
				<AdminInputText error={validation?.[0]?.description} label="Description" onChange={e => setFormData(prev => ({...prev, description: e.target.value}))} value={formData.description} />
				<AdminFieldContainer error={validation?.[0]?.content} label="Content"><Editor onChange={e => setFormData(prev => ({...prev, content: e.target.value}))} value={formData.content ?? ""} /></AdminFieldContainer>
				{locale === "en" && <AdminInputSwitch error={validation?.[0]?.linearProgression} label="Linear Progression" onChange={() => setFormData(prev => ({...prev, linearProgression: !prev.linearProgression}))} checked={formData.linearProgression} />}
				{locale === "en" && <AdminFieldContainer error={validation?.[0]?.curriculum} required label="Curriculum"><AdminCourseCurriculum initialData={entity} onChange={e => setFormData(prev => ({...prev, curriculum: e}))}/></AdminFieldContainer>}
				{locale === "en" && <AdminInputSwitch error={validation?.[0]?.privacy} label="Share" onChange={(e) => setFormData(prev => ({...prev, privacy: e.target.checked ? "global" : "cohort"}))} checked={formData.privacy === "global"} />}
				{locale === "en" && <AdminFileInput error={validation?.[0]?.featuredImage} required label="Featured Image" onChange={e => {
					if(Array.isArray(e)){
						if(typeof e[0] === "number")
							return; //featured image is single
						else {
							const f = e as IDropzoneFile[];
							setFiles(prev => ({...prev, featuredImage: f}));
						}
					}
					else if(e !== null)
						setFormData(prev => ({...prev, featuredImage: e}))
					else
						setFormData(prev => ({...prev, featuredImage: null}))
				}} files={files.featuredImage ?? []} value={formData.featuredImage} initialValue={entity?.featuredImage}/>}
				{locale === "en" && <AdminInputSelect<string> error={(validation?.[0] as any)?.contentType} required label={"Content Type"} onChange={e => setFormData(prev => ({...prev, contentType: e.target.value}))} options={contentTypes.map(e => ({label: e, value: e}))} value={(formData as any).contentType?.toString() ?? ""}/>}
			</>}
		</AdminEntityPageContainer>
	);
}
